import React from 'react';
import ToolPageLayout from '../tools/ToolPageLayout';
import UnitEconomics from './UnitEconomics';
import './UnitEconomics.css';

const UnitEconomicsPage = () => {

  return (
    <ToolPageLayout
      pageTitle={'Юнит-экономика на минималках'}
      title={
        <>
          {'Юнит-экономика'}
          <br />
          <em>{'на минималках'}</em>
        </>
      }
      lead={'Введите показатели своего бизнеса — калькулятор посчитает прибыль на продажу, допустимый CPL и план на следующий месяц.'}
      headerTag={'Юнит-экономика'}
      wide
      showEyebrow={false}
    >
      <UnitEconomics />
    </ToolPageLayout>
  );
};

export default UnitEconomicsPage;
